import {Typography} from "@material-ui/core";
import React from "react";

function NotFound() {
  return <Typography variant="h1">404 NotFound</Typography>;
}
export default NotFound;
